export default function (Component) {
Component.options.__title = "Search Input with Auto Complete"
}